<template>
  <template-layout
    :breadCrumbList="breadcrumbComputed"
    v-if="householdInformation"
  >
    <div class="py-12 px-4">
      <nav class="mb-2">
        <h1 class="text-2xl text-theme-1">
          ข้อมูลครัวเรือน
        </h1>
      </nav>
      <div class="w-1/6 h-1/6 mx-auto" v-if="householdInformationLoading">
        <LoadingIcon icon="oval" class="w-8 h-8 text-white" />
      </div>
      <div class="grid grid-cols-2 gap-6" v-else>
        <div class="col-span-2">
          <Infomation
            :information="householdInformation"
            @show-edit-modal="handleclickEditHousehold"
          />
        </div>
        <div class="col-span-2">
          <CardLayout
            headerText="รูปภาพครัวเรือน"
            headerButtonText="+ เพิ่มรูปภาพ"
            @click-header-button="openEditImageModal(true)"
            :showHeaderButton="getAllowActionByCurrRole('edit-household')"
          >
            <ModalLayout
              id="edit-householdimage-modal"
              v-model="editImage"
              @click:cancel="handleImageCancelEdit"
              @click:save="handleImageSaveEdit"
            >
              <span>เพิ่มรูปภาพครัวเรือน</span>
              <div class="flex flex-row justify-end">
                <button class="btn btn-primary" @click="addImageInput">
                  + เพิ่มรูปภาพ
                </button>
              </div>
              <div v-for="(item, index) in tempImage" :key="item">
                <FileInput
                  class="my-2"
                  :id="`inputImageFile${index}`"
                  desc="หนังสือให้ความยินยอม"
                  :label="tempImage[index].img_label"
                  v-model="tempImage[index].image"
                  @click:delete="handelDeleteImage($event, index)"
                  @update:label="updateImageLabel($event, index)"
                  :hide-delete-button="index < 4 ? true : false"
                  :disabled-label="index < 4 ? true : false"
                  :show-label="true"
                  accept-file="image/*"
                />
              </div>
            </ModalLayout>
            <div class="relative">
              <div class="mx-6">
                <TinySlider
                  :options="{
                    controls: true,
                    autoplay: false,
                    items: 1,
                    responsive: {
                      1024: {
                        items: 5,
                      },
                      720: {
                        items: 3,
                      },
                      500: {
                        items: 2,
                      },
                    },
                  }"
                >
                  <div
                    v-for="(item, index) in householdInformation.house_images"
                    :key="item.file_name"
                  >
                    <PreviewFile
                      class="m-2"
                      :value="item"
                      :id="'preview-image-modal' + index"
                    />
                  </div>
                </TinySlider>
              </div>
            </div>
          </CardLayout>
        </div>
        <div class="h-auto col-span-2 lg:col-span-1">
          <CardLayout
            :showHeaderButton="false"
            headerText="สถานะทางการเงิน (ต่อเดือน)"
          >
            <div class="flex items-center h-full">
              <DonutChart
                :height="200"
                :seriesData="seriesDataComputed"
                :chartLabel="['รายได้', 'เงินออม', 'รายจ่าย', 'หนี้สิน']"
                :totalData="totalAmountComputed"
              />
            </div>
          </CardLayout>
        </div>
        <!-- <div class="h-auto col-span-2 lg:col-span-1">
          <CardLayout :showHeaderButton="false" headerText="ทรัพย์สิน">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <CustomAccordion headerText="ที่ดิน" :detail="firstSubSin" />
                <CustomAccordion
                  headerText="สัตว์เศรษฐกิจ"
                  :detail="secondSubSin"
                />
              </div>
              <div>
                <CustomAccordion headerText="ทอง" :detail="thridSubSin" />
                <CustomAccordion
                  headerText="สิ่งปลูกสร้าง"
                  :detail="forthSubSin"
                />
              </div>
            </div>
          </CardLayout>
        </div> -->
        <div class="h-auto col-span-2 lg:col-span-1">
          <CardLayout
            headerText="พิกัดบ้าน"
            class="map-height"
            @click-header-button="handleclickEditMap"
            :showHeaderButton="getAllowActionByCurrRole('edit-household')"
          >
            <ModalLayout
              id="edit-map-modal"
              v-model="editMap"
              @click:cancel="handleMapCancelEdit"
              @click:save="handleMapSaveEdit"
              manualHide
            >
              <div class="map-modal-height">
                <LeafletMap
                  :edit="editMap"
                  :lat="householdInformation.latitude"
                  :lng="householdInformation.longitude"
                  @update:lat="handleUpdateLat"
                  @update:lng="handleUpdateLng"
                  id="edit-map"
                />
              </div>
            </ModalLayout>
            <LeafletMap
              id="information-map"
              :lat="householdInformation.latitude"
              :lng="householdInformation.longitude"
            />
          </CardLayout>
        </div>
        <div class="h-auto col-span-2 lg:col-span-2">
          <CardLayout
            headerText="แผนผังครัวเรือน"
            headerButtonText="แสดง"
            @click-header-button="handleclickFullscreenFamilyTree"
          >
            <ModalLayout
              id="fullscreen-familytree-modal"
              v-model="fullscreenTreeModal"
              class="overflow-y-hidden"
              close-button
            >
              <div class="family-modal-height">
                <div class="edit-famtree-height">
                  <FamilyTree
                    v-if="!FamilyTreeLoading"
                    :edit="false"
                    id="view-fullscreen-familytree"
                    :tree-data="fullscreenTreeNodeData"
                    :relation-data="fullscreenTreeRelationData"
                    @onclickNode="handleClickFullscreenNode"
                  />
                </div>
              </div>
              <template v-slot:btn>
                <div></div>
              </template>
            </ModalLayout>
            <FamilyTree
              v-if="!FamilyTreeLoading"
              :edit="false"
              id="view-familytree"
              :tree-data="stateTreeNodeData"
              :relation-data="stateTreeRelationData"
              @onclickNode="handleClickNode"
            />
          </CardLayout>
        </div>
        <div class="col-span-2">
          <CardLayout
            headerText="ครอบครัว"
            headerButtonText="+ เพิ่มครอบครัว"
            @click-header-button="openAddFamilyModal(true)"
            :showHeaderButton="getAllowActionByCurrRole('create-family')"
          >
            <!-- <AddFamilyModal
              :addFamilyModal="addFamilyModal"
              :addressData="householdInformation"
              @modal-value="clearValue"
            /> -->
            <FamilyDatatable :data-array="dataArray" />
          </CardLayout>
        </div>
        <div class="col-span-2">
          <CardLayout
            headerText="หนังสือให้ความยินยอม"
            headerButtonText="+ เพิ่มไฟล์"
            @click-header-button="openEditFileModal(true)"
            :showHeaderButton="getAllowActionByCurrRole('edit-household')"
          >
            <ModalLayout
              id="edit-file-modal"
              v-model="editFile"
              @click:cancel="handleFileCancelEdit"
              @click:save="handleFileSaveEdit"
            >
              <span>เพิ่มหนังสือยินยอม</span>
              <div class="flex flex-row justify-end">
                <button class="btn btn-primary" @click="addInput">
                  + เพิ่มไฟล์
                </button>
              </div>
              <FileInput
                v-for="(item, index) in tempFile"
                class="my-2"
                :id="`inputFile${index}`"
                :key="item"
                desc="หนังสือให้ความยินยอม"
                v-model="tempFile[index]"
                @click:delete="handelDelete($event, index)"
              />
            </ModalLayout>
            <div class="flex flex-wrap">
              <PreviewFile
                class="m-2"
                v-for="(item, index) in householdInformation.consent"
                :id="'preview-consent-modal' + index"
                :key="item.file_name"
                :value="item"
                :type="
                  item.file_name.split('.').pop() === 'pdf'
                    ? 'consent'
                    : 'image'
                "
              />
            </div>
          </CardLayout>
        </div>
        <div class="col-span-2">
          <CardLayout
            headerText="ผู้รับผิดชอบครัวเรือน"
            @click-header-button="openEditVolunteerModal(true)"
            :showHeaderButton="getCurrentRole() == 'cm' || (getCurrentRole() != 'cm' && getCurrentRole() != 'vt' &&getAllowActionByCurrRole('edit-household'))"
          >
            <EditVolunteerModal
              :editVolunteerModal="editVolunteerModal"
              :staffData="householdInformation"
              @clear-edit-volunteer-modal="clearValue"
            />
            <div class="grid grid-cols-12">
              <span class="xs:col-span-12 md:col-span-3 ml-2 font-semibold"
                >เจ้าหน้าที่ พม. (case manager)</span
              >
              <span class="xs:col-span-12 md:col-span-3 ml-2 text-theme-37">
                {{ householdInformation.case_manager.title
                }}{{ householdInformation.case_manager.name }}
                {{ householdInformation.case_manager.surname }}
              </span>
            </div>
            <div class="grid grid-cols-12">
              <!-- <div class="col-span-1"></div> -->
              <span
                class="xs:col-span-12 md:col-span-3 xs:mt-4 md:my-4 ml-2 font-semibold"
                >อพม. (volunteer)</span
              >
              <span
                v-if="householdInformation.volunteer.name"
                class="xs:col-span-12 md:col-span-3 md:my-4 ml-2 text-theme-37"
              >
                {{ householdInformation.volunteer.title
                }}{{ householdInformation.volunteer.name }}
                {{ householdInformation.volunteer.surname }}
              </span>
              <span
                v-else
                class="xs:col-span-12 md:col-span-3 md:my-4 ml-2 text-theme-37"
              >
                -
              </span>
            </div>
          </CardLayout>
        </div>
        <div class="col-span-2">
          <!-- <div
            class="alert alert-danger-soft show flex items-center justify-between mb-2 border-2 border-theme-36"
            role="alert"
          >
            <p class="text-theme-36 font-semibold text-base">
              ยังไม่ได้ระบุผู้ให้ข้อมูล
            </p>
            <button
              class="py-3 px-4 text-white bg-theme-36 hover:bg-opacity-80 rounded-md"
            >
              เพิ่มผู้ให้ข้อมูล
            </button>
          </div> -->

          <!-- <CardLayout
            headerText="ผู้ให้ข้อมูล"
            @click-header-button="openEditInformantModal(true)"
          > -->
          <!-- <EditInformantModal
              :editInformantModal="editInformantModal"
              :householdData="householdInformation"
              @clear-edit-volunteer-modal="clearValue"
            /> -->
          <!-- <div class="grid grid-cols-12">
              <span class="xs:col-span-12 md:col-span-3 ml-2 font-semibold">ผู้ให้ข้อมูล</span>
              <span class="xs:col-span-12 md:col-span-3 ml-2 text-theme-37">
                {{ householdInformation.case_manager.title
                }}{{ householdInformation.case_manager.name }}
                {{ householdInformation.case_manager.surname }}
              </span>
            </div>
          </CardLayout> -->
        </div>
      </div>
    </div>
    <AddFamilyModal
      :addFamilyModal="addFamilyModal"
      :addressData="householdInformation"
      @modal-value="clearValue"
    />
    <AddHouseHoldModal
      :addHouseholdModal="addHouseholdModal"
      :editModal="editHousehold"
      @modal-value="clearValue"
    />
    <!-- <EditVolunteerModal
      :editVolunteerModal="editVolunteerModal"
      :householdData="householdInformation"
      @clear-edit-volunteer-modal="clearValue"
    /> -->
    <!-- <EditInformantModal
      :editVolunteerModal="EditInformantModal"
      :householdData="householdInformation"
      @clear-edit-volunteer-modal="clearValue"
    /> -->
  </template-layout>
</template>

<script setup>
import { reactive, ref, watch, onMounted, computed } from "vue";
import Infomation from "./container/Infomation.vue";
import CardLayout from "@/components/profile/layout/CardLayout.vue";
import DonutChart from "@/components/donut-chart/Main.vue";
import LeafletMap from "@/components/leaflet-map/index.vue";
import CustomAccordion from "@/components/base/custom-accordion/index.vue";
import FamilyDatatable from "./ProfileDatatable.vue";
import ModalLayout from "@/components/base/modal-layout/ModalLayout.vue";
import TemplateLayout from "@/layouts/side-menu/Main.vue";
import AddFamilyModal from "@/components/add-family-modal/index.vue";
import AddHouseHoldModal from "@/components/add-house-hold-modal/index.vue";
import EditVolunteerModal from "@/components/edit-volunteer-modal/index.vue";
import EditInformantModal from "@/components/edit-informant-modal/index.vue";
import FamilyTree from "@/components/family-tree/index.vue";
import PreviewFile from "@/components/base/preview-file/index.vue";
import FileInput from "@/components/base/file-input/index.vue";
import axios from "axios";
import Swal from "sweetalert2";
import { useStore } from "vuex";
import { useRoute,useRouter } from "vue-router";
import { uploadfile, compressImage } from "@/utils/minio.js";
import {
  stratify,
  flattenOnlyData,
} from "@/components/family-tree/utils/helper";
import { getAllowActionByCurrRole, getCurrentRole } from "@/utils/get-roles"

const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: "btn btn-primary m-1",
    cancelButton: "btn btn-outline-secondary m-1",
  },
  buttonsStyling: false,
});

const store = useStore();
const route = useRoute();
const router = useRouter();
const addInput = () => {
  tempFile.value.push(null);
};
const handelDelete = (evt, index) => {
  tempFile.value = tempFile.value.filter((item, i) => index != i);
};

// temp Data
const firstSubSin = [
  { title: "อาศัย", value: 2, unit: "ไร่" },
  { title: "ทำกิน", value: 2, unit: "ไร่" },
  { title: "มรดก", value: 2, unit: "ไร่" },
];
const secondSubSin = [
  { title: "หมู", value: 20, unit: "ตัว" },
  { title: "ไก่", value: 10, unit: "ตัว" },
  { title: "วัว", value: 2, unit: "ตัว" },
];

const thridSubSin = [
  { title: "สร้อย", value: 1, unit: "บาท" },
  { title: "ทองแท่ง", value: 10, unit: "บาท" },
  { title: "กำไร", value: 2, unit: "บาท" },
];
const forthSubSin = [
  { title: "บ้าน", value: 2, unit: "ไร่" },
  { title: "โรงนา", value: 1, unit: "ไร่" },
  { title: "อาคารพาณิชย์", value: 2, unit: "คูหา" },
];
// temp Data
const fullscreenTreeModal = ref(false);
const allTreeNodeData = ref([]);
const allTreeRelationData = ref([]);
const fullscreenTreeNodeData = ref([]);
const fullscreenTreeRelationData = ref([]);
const fullscreenshowFamily = ref([]);
const stateTreeNodeData = ref([]);
const stateTreeRelationData = ref([]);
const showFamily = ref([]);
const FamilyTreeLoading = ref(true);
// const role = ref("");
const householdInformation = ref(null);
const householdInformationLoading = ref(true);
const addFamilyModal = ref(false);
const addHouseholdModal = ref(false);
const editHousehold = ref(false);
const editVolunteerModal = ref(false);
const editInformantModal = ref(false);
const editMap = ref(false);
const dataArray = ref([]);
const testlatlng = ref({
  lat: 13.720564133220474,
  lng: 100.49031257629396,
});
const editFile = ref(false);
const tempFile = ref([]);
const editImage = ref(false);
const tempImage = ref([]);

watch(
  () => [...showFamily.value],
  () => {
    handleShowTreeChange();
  }
);
watch(
  () => [...showFamily.value],
  () => {
    handleShowTreeChange();
  }
);
watch(
  () => [...fullscreenshowFamily.value],
  () => {
    handleShowFullscreenTreeChange();
  }
);
watch(fullscreenTreeModal, () => {
  if (fullscreenTreeModal.value) {
    fullscreenTreeNodeData.value = allTreeNodeData.value;
    fullscreenTreeRelationData.value = allTreeRelationData.value;
  }
});

onMounted(() => {
  getData();
  // checkRole();
});
// const checkRole = () => {
//   role.value = store.getters["userAuth/getUserRoleCode"];
// };
const openAddFamilyModal = (val) => {
  addFamilyModal.value = val;
};
const openEditInformantModal = (val) => {
  editInformantModal.value = val;
};
const openEditVolunteerModal = (val) => {
  editVolunteerModal.value = val;
};
const clearValue = (val) => {
  addFamilyModal.value = false;
  editHousehold.value = false;
  editVolunteerModal.value = false;
  addHouseholdModal.value = false;
  editInformantModal.value = false;
  //call api after save modal
  if (val == "saved") {
    getData();
  }
};
const handleUpdateLat = (evt) => {
  householdInformation.value.latitude = evt;
};
const handleUpdateLng = (evt) => {
  householdInformation.value.longitude = evt;
};
const handleclickEditMap = () => {
  editMap.value = !editMap.value;
};
const handleMapCancelEdit = () => {
  editMap.value = false;
};
const handleMapSaveEdit = () => {
  swalCustom.fire({
    text:"ยืนยันบันทึกข้อมูล",
    icon:"info",
    showCancelButton: true,
    reverseButtons: true,
    confirmButtonText: 'ตกลง',
    cancelButtonText: 'ยกเลิก',
  }).then(async (result) => {
    if (result.isConfirmed) {
      try{
        let res = await axios.put(`${process.env.VUE_APP_BASE_API}household/${householdInformation.value._id} `,{
          update:{
            latitude: householdInformation.value.latitude,
            longitude: householdInformation.value.longitude
          }
        })
        if(res.status == 200){
          swalCustom.fire({
            text: "สำเร็จ",
            icon: "success",
            timer: 3000,
            confirmButtonText: "ปิด",
          }).then(()=>{
            handleMapCancelEdit()
          });
        }else{
          swalCustom.fire({
            text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
            icon: "warning",
            //timer: 3000, //timeOut for auto-close
            confirmButtonText: "ปิด",
          })
        }
      }
      catch(error){
        console.log("Error ",error);
        swalCustom.fire({
          text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
          icon: "warning",
          //timer: 3000, //timeOut for auto-close
          confirmButtonText: "ปิด",
        })
      }
    }
  })
};
const handleclickEditHousehold = () => {
  editHousehold.value = !editHousehold.value;
  addHouseholdModal.value = !addHouseholdModal.value;
};

const openEditFileModal = (boo) => {
  if (boo)
    tempFile.value = JSON.parse(
      JSON.stringify(
        householdInformation.value.consent
          ? householdInformation.value.consent
          : []
      )
    );
  editFile.value = boo;
};
const handleFileCancelEdit = () => {};
const handleFileSaveEdit = async () => {
  householdInformationLoading.value = true;
  const temp = [];
  let errorState = false;
  for (let index = 0; index < tempFile.value.length; index++) {
    let value = tempFile.value[index];
    if (!value) continue;
    if (!(value instanceof File)) {
      temp.push(JSON.parse(JSON.stringify(value)));
      continue;
    }
    value = await compressImage(value).catch((err) => {
      console.log(err);
      return err;
    });
    const res = await uploadfile(
      value,
      `documents/${householdInformation.value._id}`,
      `consent-form-${index}`
    ).catch(() => {
      errorState = true;
      swalCustom.fire({
        icon: "warning",
        // text: `บันทึกไฟล์ ${value.name} ไม่สำเร็จ`,
            text: `บันทึกไฟล์รูปภาพไม่สำเร็จ`,
        confirmButtonText: "ปิด",
      });
    });
    if (res.res.status === 200) {
      temp.push({
        file_label: "หนังสือให้ความยินยอม",
        file_name: res.file_name,
        url: res.url,
        created_date: new Date(),
      });
    } else {
      errorState = true;
    }
  }
  if (!errorState) {
    updateHouseHold({ consent: temp });
  } else {
    swalCustom.fire({
      icon: "warning",
      text: `บันทึกไฟล์ไม่สำเร็จ`,
      confirmButtonText: "ปิด",
    });
  }
};
const openEditImageModal = (bool) => {
  if (bool) {
    if (householdInformation.value.house_images) {
      let temp = householdInformation.value.house_images.map((item) => {
        if (typeof item.image === "undefined")
          return { img_label: item.img_label, image: item };
        return item;
      });
      // array1.splice(1, 0, {num:22})
      if (temp[0].img_label !== "ภายนอก (ทั้งหลัง)")
        temp.splice(0, 0, {
          img_label: "ภายนอก (ทั้งหลัง)",
          image: null,
        });
      if (temp.length < 2 || temp[1].img_label !== "ภายใน (ทั้งหลัง)")
        temp.splice(1, 0, {
          img_label: "ภายใน (ทั้งหลัง)",
          image: null,
        });
      if (temp.length < 3 || temp[2].img_label !== "ภายใน (ความเป็นอยู่)")
        temp.splice(2, 0, {
          img_label: "ภายใน (ความเป็นอยู่)",
          image: null,
        });
      if (temp.length < 4 || temp[3].img_label !== "ภายใน (ความเป็นอยู่)")
        temp.splice(3, 0, {
          img_label: "ภายใน (ความเป็นอยู่)",
          image: null,
        });

      temp = JSON.parse(JSON.stringify(temp));
      tempImage.value = temp;
    } else {
      tempImage.value = [
        {
          img_label: "ภายนอก (ทั้งหลัง)",
          image: null,
        },
        {
          img_label: "ภายใน (ทั้งหลัง)",
          image: null,
        },
        {
          img_label: "ภายใน (ความเป็นอยู่)",
          image: null,
        },
        {
          img_label: "ภายใน (ความเป็นอยู่)",
          image: null,
        },
      ];
    }
  }
  editImage.value = bool;
};
const handleImageCancelEdit = () => {};
const handleImageSaveEdit = async () => {
  householdInformationLoading.value = true;
  const result = [];
  let errorState = false;
  for (let index = 0; index < tempImage.value.length; index++) {
    if (tempImage.value[index].image) {
      let value = tempImage.value[index].image;
      const img_label = tempImage.value[index].img_label;
      let errorState = false;
      if (!value) continue;
      if (!(value instanceof File)) {
        const temp = { ...JSON.parse(JSON.stringify(value)), img_label };
        result.push(temp);
        continue;
      }

      value = await compressImage(value).catch((err) => {
        console.log(err);
        return err;
      });

      const res = await uploadfile(
        value,
        `images/${householdInformation.value._id}`,
        `household-image-${index}`
      ).catch(() => {
        errorState = true;
        swalCustom.fire({
          icon: "warning",
          text: `บันทึกไฟล์ไม่สำเร็จ`,
          confirmButtonText: "ปิด",
        });
      });
      if (res.res.status === 200) {
        result.push({
          img_label: img_label,
          file_name: res.file_name,
          img_url: res.url,
          created_date: new Date(),
        });
      }else if(res.res.response.status === 503){
        swalCustom.fire({
      icon: "warning",
            text: `บันทึกไฟล์รูปภาพไม่สำเร็จ`,
      // text: `บันทึกไฟล์ ${value.name} ไม่สำเร็จ`,
      confirmButtonText: "ปิด",
    }).then(()=>{
    router.go(0)})
    return;
      } else {
        errorState = true;
        
      }
    }
  }
  if (!errorState) {
    if (result.length > 0) updateHouseHold({ house_images: result });
    else updateHouseHold({ house_images: null });
  } else {
    swalCustom.fire({
      icon: "warning",
            text: `บันทึกไฟล์รูปภาพไม่สำเร็จ`,
      // text: `บันทึกไฟล์ ${value.name} ไม่สำเร็จ`,
      confirmButtonText: "ปิด",
    });
    return;
  }
};
const addImageInput = () => {
  tempImage.value.push({
    img_label: "อื่นๆ",
    image: null,
  });
};
const handelDeleteImage = (evt, index) => {
  tempImage.value = tempImage.value.filter((item, i) => index != i);
};
const updateImageLabel = (event, index) => {
  tempImage.value[index].img_label = event;
};

const updateHouseHold = async (update) => {
  const url = `${process.env.VUE_APP_BASE_API}household/${route.params.hhid}`;
  const res = await axios.put(url, { update }).catch(() => {
    swalCustom.fire({
      text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
      icon: "warning",
      //timer: 3000, //timeOut for auto-close
      confirmButtonText: "ปิด",
    });
  });
  if (res.status === 200) {
    swalCustom.fire({
      text: "สำเร็จ",
      icon: "success",
      timer: 3000,
      confirmButtonText: "ปิด",
    });
  }
  getData();
};

const getData = async () => {
  householdInformationLoading.value = true;
  const token = store.getters["userAuth/getToken"];
  const url = `${process.env.VUE_APP_BASE_API}household/getHouseSurveyById`;
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": `application/json; charset=utf-8`,
  };
  const res = await axios
    .post(url, { houseId: route.params.hhid }, { headers })
    .catch(() =>
      Swal.fire({
        icon: "warning",
        text: "ระบบผิดพลาด",
      })
    );
  householdInformationLoading.value = false;
  if (res.status === 200) {
    householdInformation.value = res.data;
    dataArray.value = res.data.family;
    getFamilyTreeData();
  }
};
const breadcrumbComputed = computed(() => {
  let array = [
    {
      name: "ครัวเรือน",
      path: "main-house-hold",
    },
  ];
  if (householdInformation.value?._id) {
    array.push({
      name: "ข้อมูลครัวเรือน",
      active: true,
    });
  }
  return array;
});

const getFamilyTreeData = async () => {
  FamilyTreeLoading.value = true;
  let householdTree = [
    {
      child: "root",
      parent: "",
      // hidden: true,
      data: { title: `แผนผังครัวเรือน` },
      no_parent: true,
      relationWithParent: "",
    },
  ];
  let householdRelation = [];
  await allFam.forEach(async (fam, index) => {
    if (fam.familyTree) {
      let tempTree = fam.familyTree.node;
      let tempRelation = fam.familyTree.relation;
      await tempTree.forEach((node) => {
        if (node.parent === "root") {
          if (node.family_head) node.no_parent = false;
          node.parent = `root${index}`;
        }
        if (node.child === "root") {
          node.child = `root${index}`;
          node.parent = "root";
          // เปลี่ยนเป็นครอบครัวนาย 1
          node.data = { title: `ครอบครัว`, name: famHeadname };
          node.no_parent = false;
          node.hidden = false;
        }
        if (node.child === householdHeadId) node.householdHead = true;
      });
      householdTree = householdTree.concat(tempTree);
      householdRelation = householdRelation.concat(tempRelation);
    }
  });

  allTreeNodeData.value = householdTree;
  allTreeRelationData.value = householdRelation;

  await handleShowTreeChange();
  await handleShowFullscreenTreeChange();
  FamilyTreeLoading.value = false;
};

const handleClickNode = (evt, d) => {
  let temp = JSON.parse(JSON.stringify(showFamily.value));
  if (temp.includes(d.data.child)) {
    temp = temp.filter((item) => item !== d.data.child);
  } else {
    temp.push(d.data.child);
  }
  showFamily.value = temp;
};

const handleShowTreeChange = async () => {
  let tempTreeNode = stratify(allTreeNodeData.value);
  let tempTreeRelation = allTreeRelationData.value;

  if (tempTreeNode.children) {
    await tempTreeNode.children.forEach((node) => {
      if (!showFamily.value.includes(node.id)) node.children = undefined;
    });
  }
  tempTreeNode = await flattenOnlyData(tempTreeNode);
  const treeNodeForFilter = tempTreeNode.map((item) => item.child);
  const targetId = (r) => r?.target?.id ?? r?.target?._id;
  tempTreeRelation = (tempTreeRelation || []).filter((relation) => {
    const id = targetId(relation);
    return id != null && treeNodeForFilter.includes(id);
  });

  stateTreeNodeData.value = tempTreeNode;
  stateTreeRelationData.value = tempTreeRelation;
};

const handleShowFullscreenTreeChange = async () => {
  let tempTreeNode = stratify(allTreeNodeData.value);
  let tempTreeRelation = allTreeRelationData.value;

  if (tempTreeNode.children) {
    await tempTreeNode.children.forEach((node) => {
      if (fullscreenshowFamily.value.includes(node.id))
        node.children = undefined;
    });
  }
  tempTreeNode = await flattenOnlyData(tempTreeNode);
  const treeNodeForFilter = tempTreeNode.map((item) => item.child);
  const targetId = (r) => r?.target?.id ?? r?.target?._id;
  tempTreeRelation = (tempTreeRelation || []).filter((relation) => {
    const id = targetId(relation);
    return id != null && treeNodeForFilter.includes(id);
  });

  fullscreenTreeNodeData.value = tempTreeNode;
  fullscreenTreeRelationData.value = tempTreeRelation;
};

const handleClickFullscreenNode = (evt, d) => {
  let temp = JSON.parse(JSON.stringify(fullscreenshowFamily.value));
  if (temp.includes(d.data.child)) {
    temp = temp.filter((item) => item !== d.data.child);
  } else {
    temp.push(d.data.child);
  }
  fullscreenshowFamily.value = temp;
};

const handleclickFullscreenFamilyTree = () => {
  fullscreenTreeModal.value = true;
};

const seriesDataComputed = computed(() => {
  let result = [0, 0, 0, 0];
  if (householdInformation.value) {
    return [
      householdInformation.value.stats.sum_income,
      householdInformation.value.stats.sum_saving,
      householdInformation.value.stats.sum_expenditure,
      householdInformation.value.stats.sum_debt,
    ];
  }
  return result;
});
const totalAmountComputed = computed(() => {
  let result = 0;
  if (householdInformation.value) {
    return (
      householdInformation.value.stats.sum_income -
      householdInformation.value.stats.sum_expenditure -
      householdInformation.value.stats.sum_saving -
      householdInformation.value.stats.sum_debt
    );
  }
  return result;
});
</script>

<style lang="scss" scoped>
.map-height {
  height: 100%;
}
.map-modal-height {
  height: 60vh;
  min-height: 400px;
}
.edit-famtree-height {
  height: 95%;
}
.family-modal-height {
  height: 70vh;
  @media screen and (max-width: 600px) {
    height: 60vh;
  }
}
</style>
